export default __webpack_public_path__ + "static/media/up-pixel.c0e7daaf.svg";